<template>
    <div>
        <limitless-page-header :title="'Varumärken'">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'productbrands.edit', params: { id: 0 } }" icon="icon-plus3">Nytt varumärke</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/product_brands'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="name" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
                <template #cell_logo="{ row }">
                    <img v-if="row.logo" :src="row.logo.internal_urls.original" :alt="row.name" style="max-height: 24px;">
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'ProductBrandList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Logga',
                data: 'logo',
                sortable: false,
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/product_brands/' + row.id).focus();
            } else {
                this.$router.push({ name: 'productbrands.edit', params: { id: row.id } });
            }
        },
    },
};

</script>
